<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="purchaseTemplate.pkId > 0 ? '编辑' : '新建'"
      class="employee-edit"
      width="1200px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="purchaseTemplate"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="4">
          <el-form-item label="编号">
            <el-input v-model="purchaseTemplate.no" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="模板名称" prop="inspectionTemplateName">
            <el-input v-model="purchaseTemplate.inspectionTemplateName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工序名称" prop="processName">
            <el-input v-model="purchaseTemplate.processName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="绑定物料" prop="materialNo">
            <el-input v-model="purchaseTemplate.materialNo" placeholder="请选择物料" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectMaterial.open()"
                         :disabled="purchaseTemplate.pkId > 0"/>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-form-item label="检验标准" prop="sampleStandard">
            <el-select v-model="purchaseTemplate.sampleStandard">
              <el-option value="GBT2828"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="检验等级" prop="checkLevel">
            <el-select v-model="purchaseTemplate.checkLevel">
              <el-option value="Ⅰ"/>
              <el-option value="Ⅱ"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="AQL" prop="aql">
            <el-input v-model="purchaseTemplate.aql" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!--          <el-form-item label="物料类型" prop="materialTypeName">-->
          <!--            <el-input v-model="purchaseTemplate.materialTypeName" placeholder="请选择物料类型" readonly>-->
          <!--              <el-button slot="append" icon="el-icon-search" @click="$refs.selectMaterialType.open()"/>-->
          <!--            </el-input>-->
          <!--          </el-form-item>-->
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="描述">
          <el-input v-model="purchaseTemplate.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-row>
      <el-row>
        <el-divider/>
        <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectInspection.open()"> 添加</el-button>
        <el-table
            height="400px"
            class="childMetrialTable"
            :data="purchaseTemplate.details"
            border>
          <!--          <el-table-column type="index" label="#" align="center" width="55"/>-->
          <!--          <el-table-column prop="inspectionItemNo" align="left" label="检验编号"/>-->
          <el-table-column prop="inspectionItemName" align="left" label="名称"/>
          <el-table-column prop="inspectionCategory" align="left" label="类别"/>
          <el-table-column prop="inspectionStandard" align="left" label="检验标准"/>
          <el-table-column prop="standardValue" align="center" label="标准值">
            <template slot-scope="scope">
              <el-input v-model="scope.row.standardValue" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="maxValue" align="center" label="最大值">
            <template slot-scope="scope">
              <el-input v-model="scope.row.maxValue" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="minValue" align="center" label="最小值">
            <template slot-scope="scope">
              <el-input v-model="scope.row.minValue" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="unit" align="center" label="单位">
            <template slot-scope="scope">
              <el-input v-model="scope.row.unit" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="note" align="center" label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.note" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button type="danger" @click="deleteRow(scope.$index)"> 删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submit">确定</el-button>
    </span>
    <inspection-select ref="selectInspection" @select="selectInspection"/>
    <!--    <material-type-selector ref="selectMaterialType" @select="selectMaterialType"/>-->
    <material-select ref="selectMaterial" @select="selectMaterial"/>
  </el-dialog>
</template>

<script>
  import constants from "../../../util/constants";
  import InspectionSelect from "@/views/information/Inspection/InspectionSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";

  export default {
    name: "ProductTemplateEdit1",
    components: {MaterialSelect, InspectionSelect},
    data() {
      return {
        constants,
        positionList: [],
        dialogVisible: false,
        submitLoading: false,
        purchaseTemplate: {
          pkId: 0,
          no: "",
          inspectionTemplateName: "",
          templateType: 10,
          sampleStandard: "GBT2828",
          checkLevel: "Ⅱ",
          aql: "性能类0.4 其它类1.0",
          note: "",
          processName:"",
          processId:"",
          materialNo: "",
          materialId: "",
          materialName: "",
          specification: "",
          details: [],
        },
        ruleValidate: {
          materialNo: {required: true, message: "请选择物料", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.purchaseTemplate.pkId = row.pkId;
          this.getData();
        } else {
          this.getNode();
        }
      },

      // 根据id查询信息
      getData() {
        this.$http.get("basic", `qmTemplates/${this.purchaseTemplate.pkId}`).then((resp) => {
          if (resp.success) {
            this.purchaseTemplate = resp.data;
            console.log(resp.data);
          }
        });
      },
      // 获取编号
      getNode() {
        this.$http.get("basic", "qmTemplates/getNo").then((resp) => {
          if (resp.success) {
            this.purchaseTemplate.no = resp.data;
          }
        });
      },
      // 选择
      selectInspection(row) {
        var isExist = false;
        this.purchaseTemplate.details.forEach((item) => {
          if (item.inspectionItemNo == row.no) {
            isExist = true;
          }
        });
        if (isExist) {
          this.$message.error("重复添加");
          return;
        }
        const item = {
          inspectionItemID: row.pkId,
          inspectionItemNo: row.no,
          inspectionItemName: row.name,
          inspectionCategory: row.inspectionCategory,
          inspectionStandard: row.inspectionStandard,
          standardValue: row.standardValue,
          maxValue: row.maxValue,
          minValue: row.minValue,
          unit: row.unit,
          note: row.note,
        };
        this.purchaseTemplate.details.push(item);
      },
      // 删除选中的行
      deleteRow(index) {
        this.purchaseTemplate.details.splice(index, 1);
      },
      // 物料选择
      selectMaterial(row) {
        let no = this.purchaseTemplate.no;
        this.$http
            .get("basic", "qmTemplates/initData/" + row.materialID)
            .then((resp) => {
              if (resp.success) {
                if (resp.data.pkid > 0) {
                  this.$message.error("已存在，不可重复添加");
                } else {
                  this.purchaseTemplate = resp.data;
                  this.purchaseTemplate.no = no;
                  this.purchaseTemplate.materialName = row.materialName;
                  this.purchaseTemplate.materialNo = row.materialNO;
                  this.purchaseTemplate.materialId = row.materialID;
                  this.purchaseTemplate.specification = row.specification;
                }
              }
            })
            .catch(() => {
              // this.submitLoading = false;
            });

      },
      // 提交
      submit() {
        if (this.purchaseTemplate.pkId > 0) {
          this.handleSubmitUpdData();
        } else {
          this.handleSubmitSave();
        }
      },

      // 编辑
      handleSubmitUpdData() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .put("basic", "qmTemplates", this.purchaseTemplate)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },

      // 新建
      handleSubmitSave() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", "qmTemplates", this.purchaseTemplate)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>
